'use strict';

/**
 * The ONE address normaliser (DTOWNRETAIL-SITE-001 U10-c; promoted from purchase-api's storefront auth service
 * when port-api's holder privacy intake became its second reader): the form an address is STORED and LOOKED UP
 * in, so a sign-up, a sign-in, a newsletter row, a privacy link and an account lookup all agree on which rows are
 * one person's.
 *
 * Trim, then lower-case the whole address. The local part of an address is case-sensitive by RFC 5321 and
 * case-insensitive at every mail host that exists, and the domain is case-insensitive by definition; a system that
 * kept the case would treat `Ada@Example.com` and `ada@example.com` as two people, which no mail host does. A
 * non-string is the empty string, which no validator accepts, so a caller never stores it.
 *
 * @module @puffin-core/email-address/normalizeEmail
 */

/**
 * @param {*} value
 * @returns {string} the trimmed, lower-cased address, or `''` for anything that is not a string
 */
function normalizeEmail(value) {
  return typeof value === 'string' ? value.trim().toLowerCase() : '';
}

module.exports = { normalizeEmail };
